import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal, NgbModalModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../../modules/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ScrollingModule } from '@angular/cdk/scrolling';

import { BillingsComponent } from './billings.component';
import { UpgradePackageComponent } from './pages/upgrade-package/upgrade-packages.component';
import { BillingsRoutingModule } from './billings-routing.module';
import { AntDModule } from 'src/app/modules/shared/antd.module';
import { ChoosePackageComponent } from './pages/choose-package/choose-package.component';
import { ModalPurchaseComponent } from './components/modal-purchase/modal-purchase.component';
import { ModalQrisComponent } from './components/modal-qris/modal-qris.component';
import { ModalUnpaidComponent } from './components/modal-unpaid/modal-unpaid.component';
import { LibsModule } from '../../libs/libs.module';
import { QRCodeModule } from 'angularx-qrcode';
import { ModalAutoSubscribeComponent } from './components/modal-auto-subscribe/modal-auto-subscribe.component';

@NgModule({
  declarations: [
    BillingsComponent,
    UpgradePackageComponent,
    ChoosePackageComponent,
    ModalPurchaseComponent,
    ModalQrisComponent,
    ModalUnpaidComponent,
    ModalAutoSubscribeComponent,
  ],
  imports: [
    CommonModule,
    NgbModalModule,
    NgbPopoverModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    BillingsRoutingModule,
    AntDModule,
    LibsModule,
    QRCodeModule,
    ScrollingModule
  ],
})
export class BillingsModule { }
